import { useDispatch } from "react-redux"
import { updatePredefinedFilter, updatePendingFilters } from "../../features/leadTableFiltersSlice"
import './../../css/quilityIcons.css'
import { useSelector } from "react-redux"

function SelectedPredefinedFilterInfo () {
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(updatePredefinedFilter(predefined_filter?.name !== 'Active & New' ? {
             name: "Active & New",
            params: {
                type: "Active New",
                filterType : 'initialLoad'
            }
        } : {name: null, params: null}))
        dispatch(updatePendingFilters(true))
    }

    /**
     * @type {leadFilterOptions}
     */
    const {predefined_filter} = useSelector(state => state.leadTableFilter)
    return (
        <div style={{ minHeight: 28, paddingTop: 6, paddingBottom: 6, paddingLeft: 8, paddingRight: 4, background: '#F8F8F8', borderRadius: 6, outline: '1px var(--Colors-Border-border-primary, #E4E4E4) solid', outlineOffset: '-1px', justifyContent: 'center', alignItems: 'flex-start', gap: 15, display: 'flex', flexDirection: 'column' }}>
            <div style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'flex' }}>
                <div style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', textAlign: 'center', color: '#707070', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '600', wordWrap: 'break-word' }}>List:</div>
                <div style={{ textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', textAlign: 'center', color: '#707070', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}> {predefined_filter.name}</div>
                <div onClick={ _ => handleClose()} style={{ cursor:'pointer', width: 10, height: 10, position: 'relative' }}>
                    <div className="x-close" style={{ width: 10, height: 10, left: 1, top: 1, position: 'absolute' }} />
                </div>
            </div>
        </div>
    )
}
export default SelectedPredefinedFilterInfo